var map = {
	"./add--inspection2.png": "86ce",
	"./add-BIM.png": "a3ec",
	"./add-company.png": "42be",
	"./add-construction-log.png": "a872",
	"./add-danger-source-inspect.png": "30a5",
	"./add-danger-source.png": "7dce",
	"./add-department.png": "298e",
	"./add-equipment-info.png": "5d13",
	"./add-equipment-rent.png": "b143",
	"./add-equipment-repair.png": "b7ea",
	"./add-information.png": "3d8f",
	"./add-inspect-standard.png": "73cf",
	"./add-inspection.png": "c353",
	"./add-labour-personnel.png": "dbf8",
	"./add-labour.png": "d531",
	"./add-material.png": "cb28",
	"./add-meeting.png": "b0ed",
	"./add-multi-task.png": "d8d5",
	"./add-position.png": "01fc",
	"./add-progress-file.png": "e907",
	"./add-project-data.png": "002a",
	"./add-project.png": "5123",
	"./add-quality-check.png": "b2fe",
	"./add-quality.png": "114e",
	"./add-quality2.png": "0c85",
	"./add-safe-message.png": "61e9",
	"./add-safe-plan.png": "8614",
	"./add-safe-question.png": "ffe4",
	"./add-single-task.png": "ffc7",
	"./add-special-construction.png": "defb",
	"./start-work.png": "3d3e",
	"./stop-work.png": "9b78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2681";